import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { salesBySalespersonSearchSchema } from '../../features/reports/operational-search'
import { SalesBySalespersonPage } from '../../features/reports/sales-by-salesperson-page'

export const Route = createFileRoute('/_app/sales-by-salesperson')({
  staticData: { crumb: 'salesBySalesperson' },
  validateSearch: salesBySalespersonSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: SalesBySalespersonPage,
})
